import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, CircularProgress, ListItemText, Menu, MenuItem } from '@mui/material';
import { getClientProjectPlanReport, getClientSubTaskVisits, getProjectPlanReport, getSubTaskSiteVisits } from '../../../Redux/actions';
import { buttonStyles } from '../../../theme/formStyles';
import { saveBase64File } from '../projectSchedule.utils';
import { downloadProjectVisitsReport } from '../schedule/visitReport';

// Reports for one project: the schedule as a PDF (made on the server) and every site-visit report in one file
export default function ReportsMenu({ plan, forClient = false, onMessage }) {
    const dispatch = useDispatch();
    const [anchor, setAnchor] = useState(null);
    const [busy, setBusy] = useState(null);

    const scheduleReport = async () => {
        setAnchor(null); setBusy('schedule');
        const res = await dispatch((forClient ? getClientProjectPlanReport : getProjectPlanReport)(plan.project.id));
        setBusy(null);
        if (res?.data?.success) saveBase64File(res.data.data.base64, res.data.data.file_name);
        else onMessage?.(res?.data?.message || 'Could not make the schedule report');
    };

    const visitsReport = async () => {
        setAnchor(null); setBusy('visits');
        const subs = (plan.steps || []).flatMap(s => (s.sub_tasks || []).map(st => ({ ...st, task_name: s.label })));
        const parts = [];
        for (const st of subs) {
            const res = await dispatch((forClient ? getClientSubTaskVisits : getSubTaskSiteVisits)(st.id));
            const visits = res?.data?.success ? res.data.data || [] : [];
            if (visits.some(v => v.check_out_at)) {
                parts.push({
                    task: { sub_task_name: st.name, facility_name: plan.project.facility_name, start_date: st.start_date, end_date: st.end_date, status: st.status, spoc: st.spoc },
                    visits,
                });
            }
        }
        const total = parts.length ? await downloadProjectVisitsReport(`${plan.project.facility_name}${plan.project.description ? ` · ${plan.project.description}` : ''}`, parts) : 0;
        setBusy(null);
        if (!total) onMessage?.('No completed site visits on this project yet');
    };

    return (
        <>
            <Button size="small" variant="outlined" onClick={(e) => setAnchor(e.currentTarget)} disabled={!!busy} sx={buttonStyles.outlined}>
                {busy ? <CircularProgress size={16} sx={{ mr: 1 }} /> : '📄 '}Reports
            </Button>
            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} disableScrollLock>
                <MenuItem onClick={scheduleReport}><ListItemText primary="Schedule report (PDF)" secondary="Steps, dates, invoicing, calibration, tickets" /></MenuItem>
                <MenuItem onClick={visitsReport}><ListItemText primary="All site visits in one file" secondary="Every checked-out visit with photos" /></MenuItem>
            </Menu>
        </>
    );
}
